export default "__VITE_ASSET__DUP7gEm7__"